import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

export const ChatDesol = ({ payload, url }) => {
  useEffect(() => {
    const { detail, email, id, idType, name } = payload;
    const tiposIdentificacion = {
      1: "Física",
      2: "Jurídica",
      3: "Extranjero Residente"
    };

    setTimeout(() => {
      window.MyG2C.API.chatAsk(`
        Asunto: ${detail}
        <br/>
        Datos del cliente:
        <ul>
          <li>Nombre: ${name}</li>
          <li>Email: ${email}</li>
          <li>Tipo de identificación: ${tiposIdentificacion[idType]}</li>
          <li>Número de identificación: ${id}</li>
        </ul>
      `);
    }, 3000);
  }, [payload]);

  return (
    <div>
      <Helmet>
        <script
          type="text/javascript"
          src={url}
          id="newloaderthewavev5"
        ></script>
      </Helmet>
    </div>
  );
};
